import { Button } from '@sweep-io/sweep-design';
import { downloadCSV } from './downloadCSV';
import { useSweepNotifications } from '../../../notifications/useSweepNotifications';
import { SweepNotificationVariant } from '../../../../reducers/notificationsReducer';
import usePaywall from '../../../dashboard/paywall/usePaywall';
import DownloadCsvPaywallBlock from './DownloadCsvPaywallBlock';
import {
  ConfigurationItem,
  ConfigurationItemWithStatus,
} from '../../dependencies/DependenciesTypes';
import { addStatusAndUpdateType } from './utils';
import { useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import { ACTIONS_EVENTS } from '../../../../services/events';
import useSendBiEvent from '../../../../hooks/useSendBiEvent';
import { ButtonSize } from '@sweep-io/sweep-design/dist/components/Button/types';
import { Tag } from '../../../../apis/facades/useUserInputsApiFacade';

export enum DownloadAsCsvButtonType {
  ConfigurationItem = 'ConfigurationItem',
  Tag = 'Tag',
}

interface DownloadAsCsvProps {
  fileName: string;
  headers: { label: string; value: string }[];
  rows: ConfigurationItem[] | Tag[];
  withButtonLabel?: boolean;
  biEventProps: {
    exportType: string;
    numberOfRecords: number;
    object?: string;
  };
  buttonSize?: ButtonSize;
  type?: DownloadAsCsvButtonType;
}

export const DownloadAsCsvButton = ({
  fileName,
  headers,
  rows,
  withButtonLabel,
  biEventProps,
  buttonSize = 'tiny',
  type = DownloadAsCsvButtonType.ConfigurationItem,
}: DownloadAsCsvProps) => {
  const sendBiEvent = useSendBiEvent();
  const { addNotification } = useSweepNotifications();

  const { isPaywallActive } = usePaywall();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      {isOpen && <DownloadCsvPaywallBlock closeDialog={() => setIsOpen(false)} />}
      <Tooltip title="Download as CSV" placement="top">
        <Button
          size={buttonSize}
          variant="flat-grey"
          onClick={async () => {
            if (isPaywallActive) {
              setIsOpen(true);
              return;
            }

            const downloadedSuccessfully = downloadCSV({
              fileName,
              headers,
              rows:
                type === DownloadAsCsvButtonType.ConfigurationItem
                  ? addStatusAndUpdateType(rows as ConfigurationItemWithStatus[])
                  : (rows as Tag[]),
            });

            if (!downloadedSuccessfully) {
              addNotification({
                variant: SweepNotificationVariant.Error,
                message: 'Nothing to download',
              });
            } else {
              sendBiEvent({ name: ACTIONS_EVENTS.documentationExportCsv, props: biEventProps });
            }
          }}
          startIconName="DownloadSimple"
        >
          {withButtonLabel ? 'Download' : ''}
        </Button>
      </Tooltip>
    </Box>
  );
};
